import {
  Avatar,
  Button,
  Card,
  Group,
  Text,
  Image,
  Flex,
  SimpleGrid,
  Box,
} from "@mantine/core";
import { useTrackedStore } from "../../../../store/useStore";
import { UniversityIcon, BookIcon } from "../../static/icons/Icons";
import { useGetAllAmbassadors } from "../../../../api/ambassador/useAmbassador";
import { useSearchParams } from "react-router";
import { ExpandableBio } from "./ExpandableBio";

export const AmbassadorsGridView = () => {
  const {
    filter: { data: filterData },
    ambassadors: { page, pageSize, search },
  } = useTrackedStore();

  const _page = page();
  const _pageSize = pageSize();
  const filters = filterData();
  const _search = search();
  const [searchParams] = useSearchParams();

  const {
    data: ambassadors,
    refetch: refetchAmbassadorList,
    isFetching: isFetchingList,
  } = useGetAllAmbassadors({
    per_page: _pageSize,
    page: _page,
    params: {
      sort: "desc",
      sort_by: "id",
      search: _search,
      ...filters,
      country_id: filters?.country_id,
      state_id: filters?.state_id,
      city_id: filters?.city_id,
    },
  });

  const authenticateUser = (url: string) => {
    if (localStorage.getItem("ymXo8h") !== null) {
      const state = localStorage.getItem("ymXo8h");
      if (state !== null) {
        const parsedJSON = JSON.parse(state);
        const _identifier = parsedJSON?.state?.user?.identifier;
        const anchor = document.createElement("a");
        anchor.href = `${url}/t/${_identifier}?referral=user`;
        anchor.target = "_blank";
        anchor.rel = "noopener noreferrer";
        anchor.click();
      }
    } else {
      const anchor = document.createElement("a");
      anchor.href = `${url}/signin`;
      anchor.target = "_blank";
      anchor.rel = "noopener noreferrer";
      anchor.click();
    }
  };

  const has_profile_pic = searchParams.get("has_profile_pic");
  const has_university = searchParams.get("has_university");
  const has_degree = searchParams.get("has_degree");
  const has_location = searchParams.get("has_location");
  const has_bio = searchParams.get("has_bio");
  const has_country_flag = searchParams.get("has_country_flag");

  return (
    <SimpleGrid cols={{ base: 1, md: 2, lg: 3, sm: 2, xs: 1 }} spacing="lg">
      {ambassadors?.recordsInfo?.map((ambassador: any, index: number) => (
        <Card
          key={index}
          w="100%"
          mih="275px"
          shadow="sm"
          padding="lg"
          radius="md"
          withBorder
        >
          <Flex
            h="100%"
            direction="column"
            justify="space-between"
            align="space-between"
          >
            <Flex justify="space-between" align="start">
              <Group wrap="nowrap">
                {has_profile_pic && (
                  <Avatar
                    src={ambassador?.userInfo?.profile_picture_url}
                    size="xl"
                  />
                )}
                <Flex wrap="wrap" gap="xs" direction="column">
                  <Text size="18px" fw={700}>
                    {`${ambassador?.userInfo?.first_name || "__"}${
                      ambassador?.userInfo?.last_name
                        ? " " + ambassador.userInfo.last_name
                        : ""
                    }`}
                  </Text>
                  {has_university && (
                    <Group wrap="nowrap">
                      <Box h={20} w={20}>
                        <UniversityIcon />
                      </Box>
                      <Text size="14px" c="#5F6368" fw={400}>
                        {ambassador?.institution_data?.name ?? "__"}
                      </Text>
                    </Group>
                  )}
                  {has_degree && (
                    <Group wrap="nowrap">
                      <Box h={20} w={20}>
                        <BookIcon color="gray" />
                      </Box>
                      <Text size="14px" c="#5F6368" fw={400}>
                        {ambassador?.program_data?.name ?? "__"}
                      </Text>
                    </Group>
                  )}
                </Flex>
              </Group>
              {has_country_flag &&
                ambassador?.institution_data?.country_data?.icon_url && (
                  <Image
                    src={ambassador?.institution_data?.country_data?.icon_url}
                    alt="flag"
                    width={24}
                    height={24}
                  />
                )}
            </Flex>

            {has_location && (
              <Flex
                wrap="wrap"
                align="center"
                gap="0.5rem"
                mt={12}
                c="dimmed"
                fz="sm"
                justify="space-between"
              >
                {/* {ambassador?.country_of_origin?.name && ( */}
                <Group>
                  <Text size="14px" span c="dimmed">
                    Country:
                  </Text>{" "}
                  <Text size="14px" span c="black">
                    {ambassador?.country_of_origin?.name ?? "__"}
                  </Text>{" "}
                </Group>
                {/* )} */}
                {/* {ambassador?.state_of_origin?.name && ( */}
                <Group>
                  <Text size="14px" span c="dimmed">
                    State:
                  </Text>{" "}
                  <Text size="14px" span c="black">
                    {ambassador?.state_of_origin?.name ?? "__"}
                  </Text>{" "}
                </Group>
                {/* )} */}
                {/* {ambassador?.city_of_origin?.name && ( */}
                <Group>
                  <Text size="14px" span c="dimmed">
                    City:
                  </Text>{" "}
                  <Text size="14px" span c="black">
                    {ambassador?.city_of_origin?.name ?? "__"}
                  </Text>
                </Group>
                {/* )} */}
              </Flex>
            )}

            {has_bio && <ExpandableBio ambassador={ambassador} />}
            <Button
              onClick={() => authenticateUser(ambassador?.client_frontend_url)}
              variant="outline"
            >
              Chat with {ambassador?.userInfo?.first_name}
            </Button>
          </Flex>
        </Card>
      ))}
    </SimpleGrid>
  );
};
